import { catchAll } from '@sorare/routing';
import {
  ANY_SPORT_PLAY,
  ANY_SPORT_PLAY_EVENTTYPE,
} from '@sorare/core/src/constants/__generated__/routes';
import type { OutletTransition } from '@sorare/core/src/routing/AnimatedOutlet';
import { AnimatedOutlet } from '@sorare/core/src/routing/AnimatedOutlet';
import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

const transitions: OutletTransition[] = [
  {
    from: ANY_SPORT_PLAY,
    to: catchAll(ANY_SPORT_PLAY_EVENTTYPE),
    direction: 'rightToLeft',
    reversable: true,
  },
];

const PlayLayout = () => {
  return (
    <RequireAuth>
      <AnimatedOutlet transitions={transitions} />
    </RequireAuth>
  );
};
export default PlayLayout;
